import dnform from '../modules/DNFORM/DNFORM';
import FRM01Form from '../modules/FRM01-form/FRM01-form';
import FRM02Form from '../modules/FRM02-form/FRM02-form';
import GAL01Gallery from '../modules/GAL01-gallery/GAL01-gallery';
import HEA01Header from '../modules/HEA01-header/HEA01-header';
import HER01hero from '../modules/HER01-hero/HER01-hero';
import LST03List from '../modules/LST03-list/LST03-list';
import NL01NewsList from '../modules/NL01-news-list/NL01-news-list.vue';
import SLD03ProductSlider from '../modules/SLD03-product-slider/SLD03-product-slider';
import SLD04LogoSlider from '../modules/SLD04-logo-slider/SLD04-logo-slider';
import SRC01Search from '../modules/SRC01-search/SRC01-search';
import SzechenyiLogo from '../common/szechenyi/szechenyi'
import Vuelidate from 'vuelidate';
import centralStore from '../common/central-vuex-store/central.vuex';
import headerSearchStore from '../modules/HEA01-header/HEA01-header.vuex';
import PRO01Promo from '../modules/PRO01-promo/PRO01-promo';

document.body.addEventListener('jsLoaded', function () {
	Vue.use(Vuelidate);

	const store = new Vuex.Store(centralStore);
	store.registerModule('headerSearchStore', headerSearchStore);

	new Vue({
		store,
		components: {
			'dnform': dnform,
			'frm01-form': FRM01Form,
			'frm02-form': FRM02Form,
			'gal01-gallery': GAL01Gallery,
			'hea01-header': HEA01Header,
			'her01-hero': HER01hero,
			'lst03-list': LST03List,
			'nl01-news-list': NL01NewsList,
			'sld03-product-slider': SLD03ProductSlider,
			'sld04-logo-slider': SLD04LogoSlider,
			'src01-search': SRC01Search,
			'szechenyi-logo': SzechenyiLogo,
			'pro01-promo': PRO01Promo
		},
		el: '#vue-app'
	});
});



// WEBPACK FOOTER //
// ../source/build-entry/layout.js